module.exports = __webpack_public_path__ + "static/spa02-30188eed30a35a8f92da84ba10109ca5.jpg";